var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('app-navbar'),_c('section',{staticClass:"content"},[_c('div',{staticClass:"message-container"},[_c('h2',[_vm._v("Ops! A página que você procura não foi encontrada.")]),_c('router-link',{attrs:{"to":{ name: 'site.index' }}},[_vm._v(" Clique aqui para ser redirecionado! ")])],1)]),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }